import api from './api';

class InsightsService {
  getCatalog() {
    return api.get('/merchant/insights/catalog');
  }

  getMetric(metric) {
    return api.get(`/merchant/insights/${metric}`);
  }
}

export default new InsightsService();
